
class FileHandle
{
	/**
	 * @param {Object} pFileInfo - File metadata.
	 * @param {FileHandle} [pParent] - (optional) Parent file handle.
	 */
	constructor(pFileInfo, pParent)
	{
		this._FileInfo = pFileInfo || { };
		this._Parent = pParent || null;
	}

	get name()
	{
		return this._FileInfo.Name;
	}

	get type()
	{
		return this._FileInfo.Type;
	}

	get subType()
	{
		return this._FileInfo.SubType || '';
	}

	get path()
	{
		return this._FileInfo.Path;
	}

	get isFolder()
	{
		return this._FileInfo.IsFolder;
	}

	get index()
	{
		return this._FileInfo.Index || 0;
	}

	get parent()
	{
		return this._Parent;
	}

	get observation()
	{
		return this._FileInfo.Observation;
	}
}

module.exports = FileHandle;
module.exports.default_configuration = {};
